module.exports = __webpack_public_path__ + "img/012.c4e7e2bc.png";